export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/745ea77b1eac57714916b21323fd342f.png";